import { ConfigProvider as AntdConfigProvider } from 'antd'

import {
  antdTranslationResources,
  availableLanguages,
  type AvailableLanguageType,
  fallbackLng,
} from '@/locales/resources'

import { useDarkTheme } from '@/contexts/DarkThemeContext'
import { darkTheme } from '@/styles/theme/dark'
import { lightTheme } from '@/styles/theme/light'

type ConfigProviderProps = React.PropsWithChildren & {
  language: string
}

export function ConfigProvider({ children, language }: ConfigProviderProps) {
  const { isDarkTheme } = useDarkTheme()

  const localeKey = (
    availableLanguages.includes(language as AvailableLanguageType) ? language : fallbackLng
  ) as AvailableLanguageType

  const locale = antdTranslationResources[localeKey]

  return (
    <AntdConfigProvider theme={isDarkTheme ? darkTheme : lightTheme} locale={locale}>
      {children}
    </AntdConfigProvider>
  )
}
